import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";

const InitStateLanguage = () => {
    return localStorage.getItem("i18nextLng") === "tr" ? "us" : "tr";
};

const initialState = {
    Language: InitStateLanguage(),
};

export const ChangeLanguage = createAsyncThunk(
    "i18n/ChangeLanguage",
    async () => {
        await i18next.changeLanguage(i18next.language == "tr" ? "us" : "tr");
        return InitStateLanguage();
    }
);

export const ChangeLanguageWithValue = createAsyncThunk(
    "i18n/ChangeLanguage",
    async (lang) => {
        await i18next.changeLanguage(lang);
        return InitStateLanguage();
    }
);

const LanguageSlice = createSlice({
    name: "LanguageReducer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ChangeLanguage.fulfilled, (state, action) => {
            state.Language = action.payload;
        });
    },
});
export const { } = LanguageSlice.actions;
export default LanguageSlice.reducer;
